import { t } from 'translations'
import { store } from 'store/reducers'

type GetHiringDataNames = (hiringDataArray: Array<string | MData.HiringData>, options?: { key?: string; delimiter?: string; withDates?: boolean }) => string

export const getHiringDataNames: GetHiringDataNames = (hiringDataArray = [], { key = 'hiringDataId', delimiter = ' - ', withDates } = {}) => {
  return hiringDataArray
    .map(hiringData => {
      // Get the hiringData id
      const hiringDataId = typeof hiringData === 'object' ? hiringData[key] : hiringData

      if (typeof hiringData === 'object' && withDates) {
        return `${getHiringDataName(hiringDataId)}${getHiringDataDates(hiringData.start, hiringData.end)}`
      }
      // Obviously when using withDates, you must pass an array of objects with dates
      return getHiringDataName(hiringDataId)
    })
    .join(delimiter)
}

type GetHiringDataName = (hiringDataId: string) => string

export const getHiringDataName: GetHiringDataName = hiringDataId => {
  const {
    resources: { hiringDataById }
  } = store.getState() as MStore.RootState

  if (!hiringDataById[hiringDataId]) return t('components.HIRING_DATA_DELETED')

  return hiringDataById[hiringDataId].name
}

type GetHiringDataDates = (start: string, end: string) => string

const getHiringDataDates: GetHiringDataDates = (start, end) => {
  if (start && end) return `(${start} - ${end})`
  if (start) return `(${start})`
  if (end) return `(${end})`
  return ''
}
